export default __webpack_public_path__ + "static/media/counter-bg-section.8ae3d30c.jpg";